const NUMERIC_TYPES: DataTypesT[] = ['integer', 'float', 'fraction', 'money'];

const DATE_TYPES: DataTypesT[] = ['date', 'datetime', 'time', 'year'];

export const isNumericType = (type: DataTypesT): boolean =>
    NUMERIC_TYPES.includes(type);

export const isDateType = (type: DataTypesT): boolean =>
    DATE_TYPES.includes(type);

export const isEnumType = (type: DataTypesT): boolean => type === 'enum';

export const isCategoryLikeType = (type: DataTypesT): boolean =>
    type === 'enum' || type === 'category' || type === 'tree';
